// Org request API — used by NoOrgAccess (console) and the admin approval queue.
import { supabase } from '@govern360/shared';

// User with no org requests one. Lands in the super-admin approval queue.
export async function requestOrg(orgName, note) {
  const { data, error } = await supabase.rpc('request_org', {
    p_org_name: orgName,
    p_note: note || null,
  });
  return { data, error };
}

// (Admin console) list all requests.
export async function listOrgRequests() {
  const { data, error } = await supabase
    .from('org_requests')
    .select('*')
    .order('created_at', { ascending: false });
  return { data: data || [], error };
}

// (Admin console) approve → creates org + owner membership.
export async function approveOrgRequest(id) {
  const { data, error } = await supabase.rpc('approve_org_request', { p_request_id: id });
  return { data, error };
}

// (Admin console) deny.
export async function denyOrgRequest(id) {
  const { error } = await supabase.rpc('deny_org_request', { p_request_id: id });
  return { error };
}
